var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ExActionsPopUp',{attrs:{"value":_vm.show,"avatar":_vm.avatar,"termination":true,"headline":_vm.headline,"actionLabel":_vm.actionLabel,"htmlInfo":_vm.terminateInfo,"terminateModal":_vm.isTerminateModal},on:{"onAction":function($event){return _vm.$emit('onAction', $event)},"input":function($event){return _vm.$emit('onClose')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }